export const mapNotificationSettingsToServer = (settings) => ({
    system_notify_rent: Boolean(settings?.systemNotifyRent),
    system_notify_shift: Boolean(settings?.systemNotifyShift),
    system_notify_vk: Boolean(settings?.systemNotifyVk),
    system_notify_widget: Boolean(settings?.systemNotifyWidget),
    system_notify_tariff: Boolean(settings?.systemNotifyTariff),
    notify_before_end_rent: Boolean(settings?.notifyBeforeEndRent),
});
